<template>
    <div class="history-dialog dialog-wraper">
        <div class="version-view" v-show="!recover">
            <div class="versionbox" @scroll="handleScroll" ref="scrollbody">
                <div class="version-item-list" v-if="!initing">
                    <div class="version-item" v-for="item in histories" :key="item.id">
                        <div class="his-iconbox">
                            <wps-icon :type="dialogData.ext"/>
                        </div>
                        <div class="his-fname">
                            <span class="nowrap" v-text="$t('Version',{fver:item.fver})"></span><span v-if="item.id === 0">（{{$t('Hiscurrent')}}）</span>
                        </div>
                        <div class="his-mtime">
                            <date-pass-by :stamp="item.mtime*1000" />
                        </div>
                        <div class="his-action">
                            <div class="his-action-item his-overview" @click="overview(item.fileid,item.id,item.fname,item.groupid,item.fver)" v-t="'Overview'"></div>
                            <div v-if="item.id !== 0" class="his-action-item his-recover" @click="choseRecover(item.id,item.mtime)" v-t="'Recover'"></div>
                        </div>
                    </div>
                </div>
                <loading v-if="initing" />
            </div>
            <div class="version-tip">
                {{$t('Versiontip')}}
            </div>
        </div>
        <div class="recover-doalog" v-if="recover">
            <span class="recover-text">{{$t('Dorecover',{date,week,time})}}</span>
        </div>
        <div class="dialog-foot">
            <label for="upbtn" v-if="!recover && isCef && route !== 'latest' && route !== 'preview' && route !== 'previewHistory'">
                <span @mouseover="handleMouseover" class="el-button el-button--default el-button--mini his-newver">
                    <span>{{$t('UploadnewVer')}}</span>
                </span>
            </label>
            <el-button v-if="recover" @click="() => recover = false" v-t="'Cancel'"></el-button>
            <el-button @click="onConfirm" type="primary" size="mini" v-cloak>{{$t('Confirm')}}</el-button>
        </div>
    </div>
</template>

<script>
import {mapState,mapMutations, mapActions} from 'vuex'
import WpsIcon from '@/components/Icon'
import Loading from '@/components/Loading'
import DatePassBy from '@/components/DatePassBy'
export default {
    data(){
        return {
            recover: false,
            recoverid: 0,
            mtime: 0
        }
    },
    created(){
        this.flushHistory({flag: true,groupid:this.dialogData.groupid})
    },
    components:{
        WpsIcon,
        DatePassBy,
        Loading
    },
    methods:{
        ...mapActions([
            'close'
        ]),
        ...mapMutations([
            'SET_UPLOADTYPE'
        ]),
        ...mapActions('history',[
            'getHistory',
            'flushHistory',
            'dorecover'
        ]),
        handleScroll(){
            let target = this.$refs.scrollbody
            let contentHeight = target.offsetHeight || target.clientHeight
            let scrollTop = target.scrollTop
            let contentInnerHeight = target.scrollHeight
            if (contentInnerHeight - (scrollTop + contentHeight) >= 1 || scrollTop == 0) {
                return
            }
            this.getHistory(this.dialogData.groupid) 
        },
        handleMouseover(){
            let {ext,fname} = this.dialogData
            let history = this.histories[0] || {}
            this.SET_UPLOADTYPE({
                type:false,
                data:{
                    type: 'newver',
                    ext,
                    fname,
                    ...history
                }
            })
        },
        choseRecover(id,mtime){
            this.recover = true
            this.recoverid = id
            this.mtime = mtime
        },
        onConfirm(){
            if (this.recover) {
                let {fileid,groupid,parentid} = this.histories[0]
                let historyid = this.recoverid
                this.dorecover({
                    fileid,
                    historyid,
                    groupid,
                    parentid
                })
                this.recover = false
                this.$nextTick(() => {
                    this.$refs.scrollbody.scrollTop = 0
                })
            }else{
                this.close()
            }
        },
        overview(fileid,historyid,fname,groupid,version){
            _dw.onEvent('drive_fileaction_history_preview')
            if(window.cefQuery){
                wpsApi({method: 'openOldFile',params:{historyid,groupid ,filename:fname,fileid}},function(res){console.log(res)})
            }else{
                window.open(`/view/${fileid}${historyid ? `/${version}` : ''}`)
            }
            
        }
    },
    computed:{
        ...mapState([
            'dialogData',
            'route'
        ]),
        ...mapState('history',[
            'histories',
            'initing'
        ]),
        isCef(){
            return !window.cefQuery
        },
        date(){
            let date = new Date(this.mtime * 1000)
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
        },
        week(){
            let date = new Date(this.mtime * 1000)
            let week = [this.$t('Mon'),this.$t('Tue'),this.$t('Wed'),this.$t('Thu'),this.$t('Fri'),this.$t('Sat'),this.$t('Sun')]
            return week[date.getDay()-1]
        },
        time(){
            let date = new Date(this.mtime * 1000)
            let min = date.getMinutes()
            let hour = date.getHours()
            return `${hour > 9 ? hour : `0${hour}`}:${min > 9 ? min : `0${min}`}`
        }
    }
}
</script>

<style>
.versionbox{
    border: 1px solid #d8d8d8;
    border-radius: 1px;
    height: 300px;
    margin-top: -36px;
    position: relative;
    overflow-y: auto;
}
.version-item{
    height: 44px;
    line-height: 44px;
}
.version-item{
    display: flex;
    align-items: center;
}
.his-action{
    display: none;
    padding: 0 16px;
}
.version-item:hover .his-action{
    display: flex;
}
.version-item:hover .his-mtime{
    display: none;
}
.version-item:hover{
    background: #fafcff;
}
.version-item .his-iconbox{
    font-size: 16px;
    margin: 0 10px 0 16px;
}
.his-action-item{
    cursor: pointer;
}
.his-action-item:hover{
    color: #2e68f8;
}
.his-mtime{
    padding: 0 16px;
    white-space: nowrap;
}
.his-fname{
    flex: 1;
    display: flex;
    padding: 0 20px 0 0;
    min-width: 0;
}
.his-recover{
    margin-left: 40px;
}
.version-tip{
    padding: 10px 0;
}
.his-fname .shortname-end{
    max-height: 44px;
}
.his-newver{
    line-height: 32px;
}
.recover-text{
    line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/file/History.vue